<aside
  class="tw-box-border tw-flex tw-h-full tw-min-h-0 tw-flex-col tw-bg-white tw-font-inter"
  [ngClass]="
    mobilePicker()
      ? 'tw-w-full tw-rounded-none tw-border-0 tw-px-0 tw-py-0'
      : 'tw-w-[306px] tw-shrink-0 tw-rounded-xl tw-border tw-border-gray-200 tw-px-4 tw-py-5'
  "
>
  <div class="tw-flex tw-shrink-0 tw-flex-col tw-gap-4">
    @if (!mobilePicker()) {
      <h2 class="tw-m-0 tw-text-base tw-font-semibold tw-leading-6 tw-text-gray-900">Fields library</h2>
    }

    <div class="tw-relative">
      <input
        type="text"
        class="tw-h-10 tw-w-full tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-pl-10 tw-text-sm tw-text-gray-900 tw-outline-none placeholder:tw-text-gray-500 focus:tw-border-blue-500"
        [class.tw-pr-10]="isSearching()"
        [class.tw-pr-3]="!isSearching()"
        placeholder="Search for a field"
        [formControl]="searchControl"
        autocomplete="off"
        aria-label="Search for a field"
      />
      <span class="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-500" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0068 11.6094C12.0853 11.6088 12.1615 11.6319 12.2266 11.6738L12.2881 11.7217L15.4824 14.917C15.5383 14.9729 15.5773 15.0445 15.5928 15.1221C15.6082 15.1996 15.5996 15.2805 15.5693 15.3535C15.539 15.4264 15.4875 15.4884 15.4219 15.5322C15.3562 15.5761 15.2792 15.5996 15.2002 15.5996L15.1221 15.5918C15.0451 15.5764 14.9733 15.5387 14.917 15.4824L11.7227 12.2881C11.6499 12.2128 11.6096 12.1115 11.6104 12.0068C11.6113 11.902 11.6534 11.8007 11.7275 11.7266C11.8017 11.6527 11.9022 11.6103 12.0068 11.6094ZM5.22949 0.515625C6.39338 0.284116 7.59993 0.402329 8.69629 0.856445C9.79257 1.31053 10.7294 2.07983 11.3887 3.06641C12.0067 3.99141 12.3554 5.06891 12.3965 6.17773L12.4004 6.40039C12.3984 7.99095 11.7654 9.51591 10.6406 10.6406C9.5157 11.7655 7.99027 12.3976 6.39941 12.3994C5.21294 12.3993 4.05293 12.0478 3.06641 11.3887C2.07982 10.7294 1.31055 9.79254 0.856445 8.69629C0.402314 7.59993 0.284111 6.39338 0.515625 5.22949C0.747142 4.06562 1.31811 2.99633 2.15723 2.15723C2.99633 1.31813 4.06563 0.747148 5.22949 0.515625ZM6.40039 1.2002C5.37192 1.2002 4.36589 1.50479 3.51074 2.07617C2.65567 2.64755 1.98926 3.46004 1.5957 4.41016C1.20223 5.36016 1.09928 6.40554 1.2998 7.41406C1.50044 8.42271 1.99548 9.34993 2.72266 10.0771C3.4499 10.8044 4.37703 11.2994 5.38574 11.5C6.3943 11.7006 7.43959 11.5976 8.38965 11.2041C9.33979 10.8105 10.1522 10.1441 10.7236 9.28906C11.2949 8.43404 11.6005 7.42872 11.6006 6.40039V6.39941C11.5992 5.02088 11.05 3.69938 10.0752 2.72461C9.16131 1.81081 7.94285 1.27196 6.6582 1.20703L6.40039 1.2002Z"
            fill="currentColor"
          />
        </svg>
      </span>
      @if (isSearching()) {
        <button
          type="button"
          class="tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2 tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-gray-400 hover:tw-bg-gray-100 hover:tw-text-gray-600"
          aria-label="Clear search"
          (click)="clearSearch()"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M9 3 3 9M3 3l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>
      }
    </div>
  </div>

  <div
    class="tw-relative tw-mt-4 tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-4 tw-overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:tw-hidden"
  >
    @if (isSearching()) {
      <p class="tw-m-0 tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-500">Search results ({{ searchResults().length }})</p>
      @if (searchResults().length) {
        <div @viewSwap class="tw-w-full">
          <ul class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-2 tw-p-0" [@listStagger]="searchListKey()">
            @for (field of searchResults(); track field.form_element_type_id) {
              <li class="tw-will-change-[opacity,transform]">
                <button
                  type="button"
                  class="tw-relative tw-m-0 tw-flex tw-min-h-11 tw-w-full tw-items-center tw-gap-3 tw-overflow-hidden tw-rounded-lg tw-border tw-px-3 tw-py-2.5 tw-text-left tw-transition-[background-color,border-color] tw-duration-150 tw-ease-in-out"
                  [ngClass]="
                    field.coming_soon
                      ? 'tw-cursor-default tw-border-gray-200 tw-bg-gray-50'
                      : 'tw-cursor-pointer tw-border-gray-200 tw-bg-white hover:tw-border-gray-300 hover:tw-bg-gray-50'
                  "
                  [attr.title]="field.help_text"
                  (click)="onFieldClick(field)"
                >
                  <i
                    class="tw-h-4 tw-w-4 tw-shrink-0 tw-text-base"
                    [ngClass]="iconClass(field) + (field.coming_soon ? ' tw-text-gray-300' : ' tw-text-gray-500')"
                    aria-hidden="true"
                  ></i>
                  <span
                    class="tw-min-w-0 tw-flex-1 tw-text-sm tw-font-medium tw-leading-5"
                    [class.tw-text-gray-400]="field.coming_soon"
                    [class.tw-text-gray-500]="!field.coming_soon"
                    >{{ field.name }}</span
                  >
                  @if (!field.coming_soon && mobilePicker()) {
                    <span class="tw-inline-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-blue-600 tw-bg-white" aria-hidden="true">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="#1C64F2" />
                      </svg>
                    </span>
                  } @else if (field.coming_soon) {
                    <span class="tw-shrink-0 tw-rounded tw-bg-[#fdf6b2] tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-leading-4 tw-text-[#723b13]">Soon</span>
                  }
                </button>
              </li>
            }
          </ul>
        </div>
      } @else {
        <div @viewSwap class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-px-4 tw-py-10">
          <span class="tw-inline-flex tw-h-16 tw-w-16" aria-hidden="true">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M25.6003 51.2C20.537 51.2 15.5875 49.6986 11.3775 46.8856C7.1676 44.0726 3.88634 40.0745 1.94872 35.3967C0.0110921 30.7189 -0.495879 25.5716 0.491914 20.6057C1.47971 15.6398 3.9179 11.0783 7.49817 7.49807C11.0784 3.91785 15.64 1.47969 20.6059 0.491908C25.5719 -0.495873 30.7193 0.011092 35.3971 1.94869C40.075 3.8863 44.0732 7.16751 46.8862 11.3774C49.6992 15.5873 51.2006 20.5368 51.2006 25.6C51.193 32.3872 48.4934 38.8942 43.694 43.6935C38.8947 48.4928 32.3876 51.1924 25.6003 51.2ZM25.6003 6.40001C21.8029 6.40001 18.0907 7.52607 14.9332 9.63579C11.7758 11.7455 9.31484 14.7441 7.86162 18.2525C6.4084 21.7608 6.02817 25.6213 6.76901 29.3457C7.50986 33.0702 9.3385 36.4913 12.0237 39.1764C14.7089 41.8616 18.1301 43.6902 21.8545 44.4311C25.579 45.1719 29.4395 44.7917 32.9479 43.3385C36.4563 41.8853 39.455 39.4244 41.5647 36.2669C43.6745 33.1095 44.8005 29.3974 44.8005 25.6C44.7955 20.5094 42.7709 15.6288 39.1713 12.0292C35.5717 8.42957 30.691 6.40509 25.6003 6.40001Z"
                fill="#9CA3AF"
              />
              <path
                d="M60.8006 64C59.952 63.9998 59.1382 63.6626 58.5382 63.0624L45.7381 50.2624C45.1552 49.6589 44.8326 48.8506 44.8399 48.0115C44.8472 47.1725 45.1837 46.3699 45.777 45.7766C46.3704 45.1833 47.173 44.8467 48.012 44.8394C48.8511 44.8322 49.6594 45.1547 50.2629 45.7376L63.0631 58.5376C63.5105 58.9851 63.8151 59.5553 63.9385 60.1759C64.062 60.7965 63.9986 61.4399 63.7564 62.0245C63.5143 62.6091 63.1043 63.1089 62.5781 63.4605C62.052 63.8121 61.4335 63.9999 60.8006 64Z"
                fill="#9CA3AF"
              />
            </svg>
          </span>
          <p class="tw-m-0 tw-text-center tw-text-base tw-font-normal tw-leading-6 tw-text-gray-500">No fields found!</p>
        </div>
      }
    } @else {
      <div @viewSwap class="tw-flex tw-w-full tw-flex-col tw-gap-4">
        <section class="tw-flex tw-flex-col tw-gap-3">
          <button
            type="button"
            class="tw-m-0 tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-bg-transparent tw-p-0 tw-text-gray-500 hover:tw-text-gray-700"
            (click)="toggleFrequentlyUsed()"
            [attr.aria-expanded]="frequentlyUsedExpanded()"
          >
            <span class="tw-m-0 tw-text-sm tw-font-medium tw-leading-5">Frequently used</span>
            <svg
              class="tw-shrink-0 tw-transition-transform tw-duration-[280ms] tw-ease-[ease]"
              [class.tw-rotate-180]="!frequentlyUsedExpanded()"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M9.00142 5.82141C8.73654 5.82136 8.48254 5.71909 8.29527 5.53712L5.00624 2.34202L1.71721 5.53712C1.62508 5.62979 1.51487 5.70371 1.39301 5.75456C1.27115 5.80541 1.14009 5.83218 1.00747 5.8333C0.874854 5.83442 0.743333 5.80987 0.620585 5.76108C0.497837 5.71229 0.386319 5.64025 0.29254 5.54915C0.19876 5.45805 0.124597 5.34971 0.0743765 5.23047C0.0241563 5.11123 -0.00111471 4.98346 3.77115e-05 4.85463C0.00119014 4.7258 0.0287432 4.59848 0.081089 4.48011C0.133435 4.36173 0.209525 4.25466 0.30492 4.16516L4.3001 0.284082C4.4874 0.102184 4.7414 0 5.00624 0C5.27109 0 5.52509 0.102184 5.71239 0.284082L9.70757 4.16516C9.84721 4.30085 9.9423 4.47372 9.98082 4.66191C10.0193 4.85009 9.99956 5.04515 9.92398 5.22242C9.8484 5.39969 9.72042 5.55121 9.55621 5.65782C9.392 5.76444 9.19893 5.82137 9.00142 5.82141Z"
                fill="currentColor"
              />
            </svg>
          </button>
          <div
            class="tw-grid tw-transition-[grid-template-rows,opacity] tw-duration-[280ms] tw-ease-[ease]"
            [ngClass]="
              frequentlyUsedExpanded()
                ? 'tw-grid-rows-[1fr] tw-pointer-events-auto tw-opacity-100'
                : 'tw-grid-rows-[0fr] tw-pointer-events-none tw-opacity-0'
            "
            [attr.aria-hidden]="!frequentlyUsedExpanded()"
          >
            <div class="tw-min-h-0 tw-overflow-hidden">
              @if (loading()) {
                <div class="tw-flex tw-flex-col tw-gap-2" aria-label="Loading frequently used fields" aria-busy="true">
                  @for (item of [0, 1, 2]; track item) {
                    <span class="tw-h-11 tw-w-full tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></span>
                  }
                </div>
              } @else {
                <ul class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-2 tw-p-0" [@listStagger]="frequentlyUsed().length">
                @for (field of frequentlyUsed(); track field.form_element_type_id) {
                  <li class="tw-will-change-[opacity,transform]">
                    <button
                      type="button"
                      class="tw-relative tw-m-0 tw-flex tw-min-h-11 tw-w-full tw-cursor-pointer tw-items-center tw-gap-3 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-py-2.5 tw-pl-3 tw-pr-4 tw-text-left tw-transition-[background-color,border-color] tw-duration-150 tw-ease-in-out after:tw-pointer-events-none after:tw-absolute after:tw-inset-y-0 after:tw-right-0 after:tw-w-2 after:tw-rounded-r-lg after:tw-bg-[#ACC9FA] after:tw-content-[''] hover:tw-bg-gray-100"
                      [attr.title]="field.help_text"
                      (click)="onFieldClick(field)"
                    >
                      <i class="tw-h-4 tw-w-4 tw-shrink-0 tw-text-base tw-text-gray-500" [ngClass]="iconClass(field)" aria-hidden="true"></i>
                      <span class="tw-min-w-0 tw-flex-1 tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-500">{{ field.name }}</span>
                      @if (mobilePicker()) {
                        <span class="tw-relative tw-z-[1] tw-mr-2 tw-inline-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-blue-600 tw-bg-white" aria-hidden="true">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="#1C64F2" />
                          </svg>
                        </span>
                      }
                    </button>
                  </li>
                }
                </ul>
              }
            </div>
          </div>
        </section>

        <section class="tw-flex tw-flex-col tw-gap-3">
          <button
            type="button"
            class="tw-m-0 tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-bg-transparent tw-p-0 tw-text-gray-500 hover:tw-text-gray-700"
            (click)="toggleAllFields()"
            [attr.aria-expanded]="allFieldsExpanded()"
          >
            <span class="tw-m-0 tw-text-sm tw-font-medium tw-leading-5">All fields</span>
            <svg
              class="tw-shrink-0 tw-transition-transform tw-duration-[280ms] tw-ease-[ease]"
              [class.tw-rotate-180]="!allFieldsExpanded()"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M9.00142 5.82141C8.73654 5.82136 8.48254 5.71909 8.29527 5.53712L5.00624 2.34202L1.71721 5.53712C1.62508 5.62979 1.51487 5.70371 1.39301 5.75456C1.27115 5.80541 1.14009 5.83218 1.00747 5.8333C0.874854 5.83442 0.743333 5.80987 0.620585 5.76108C0.497837 5.71229 0.386319 5.64025 0.29254 5.54915C0.19876 5.45805 0.124597 5.34971 0.0743765 5.23047C0.0241563 5.11123 -0.00111471 4.98346 3.77115e-05 4.85463C0.00119014 4.7258 0.0287432 4.59848 0.081089 4.48011C0.133435 4.36173 0.209525 4.25466 0.30492 4.16516L4.3001 0.284082C4.4874 0.102184 4.7414 0 5.00624 0C5.27109 0 5.52509 0.102184 5.71239 0.284082L9.70757 4.16516C9.84721 4.30085 9.9423 4.47372 9.98082 4.66191C10.0193 4.85009 9.99956 5.04515 9.92398 5.22242C9.8484 5.39969 9.72042 5.55121 9.55621 5.65782C9.392 5.76444 9.19893 5.82137 9.00142 5.82141Z"
                fill="currentColor"
              />
            </svg>
          </button>
          <div
            class="tw-grid tw-transition-[grid-template-rows,opacity] tw-duration-[280ms] tw-ease-[ease]"
            [ngClass]="
              allFieldsExpanded() ? 'tw-grid-rows-[1fr] tw-pointer-events-auto tw-opacity-100' : 'tw-grid-rows-[0fr] tw-pointer-events-none tw-opacity-0'
            "
            [attr.aria-hidden]="!allFieldsExpanded()"
          >
            <div class="tw-min-h-0 tw-overflow-hidden">
              <ul class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-2 tw-p-0">
                @for (field of allFields(); track field.form_element_type_id) {
                  <li class="tw-will-change-[opacity,transform]">
                    <button
                      type="button"
                      class="tw-relative tw-m-0 tw-flex tw-min-h-11 tw-w-full tw-cursor-pointer tw-items-center tw-gap-3 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-3 tw-py-2.5 tw-text-left tw-transition-[background-color,border-color] tw-duration-150 tw-ease-in-out hover:tw-border-gray-300 hover:tw-bg-gray-50"
                      [attr.title]="field.help_text"
                      (click)="onFieldClick(field)"
                    >
                      <i class="tw-h-4 tw-w-4 tw-shrink-0 tw-text-base tw-text-gray-500" [ngClass]="iconClass(field)" aria-hidden="true"></i>
                      <span class="tw-min-w-0 tw-flex-1 tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-500">{{ field.name }}</span>
                      @if (mobilePicker()) {
                        <span class="tw-inline-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-blue-600 tw-bg-white" aria-hidden="true">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="#1C64F2" />
                          </svg>
                        </span>
                      }
                    </button>
                  </li>
                }
              </ul>
            </div>
          </div>
        </section>

        <section class="tw-flex tw-flex-col tw-gap-3">
          <button
            type="button"
            class="tw-m-0 tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-gap-2 tw-border-0 tw-bg-transparent tw-p-0 tw-text-gray-500 hover:tw-text-gray-700"
            (click)="toggleComingSoon()"
            [attr.aria-expanded]="comingSoonExpanded()"
          >
            <span class="tw-m-0 tw-text-sm tw-font-medium tw-leading-5">Coming soon</span>
            <svg
              class="tw-shrink-0 tw-transition-transform tw-duration-[280ms] tw-ease-[ease]"
              [class.tw-rotate-180]="!comingSoonExpanded()"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M9.00142 5.82141C8.73654 5.82136 8.48254 5.71909 8.29527 5.53712L5.00624 2.34202L1.71721 5.53712C1.62508 5.62979 1.51487 5.70371 1.39301 5.75456C1.27115 5.80541 1.14009 5.83218 1.00747 5.8333C0.874854 5.83442 0.743333 5.80987 0.620585 5.76108C0.497837 5.71229 0.386319 5.64025 0.29254 5.54915C0.19876 5.45805 0.124597 5.34971 0.0743765 5.23047C0.0241563 5.11123 -0.00111471 4.98346 3.77115e-05 4.85463C0.00119014 4.7258 0.0287432 4.59848 0.081089 4.48011C0.133435 4.36173 0.209525 4.25466 0.30492 4.16516L4.3001 0.284082C4.4874 0.102184 4.7414 0 5.00624 0C5.27109 0 5.52509 0.102184 5.71239 0.284082L9.70757 4.16516C9.84721 4.30085 9.9423 4.47372 9.98082 4.66191C10.0193 4.85009 9.99956 5.04515 9.92398 5.22242C9.8484 5.39969 9.72042 5.55121 9.55621 5.65782C9.392 5.76444 9.19893 5.82137 9.00142 5.82141Z"
                fill="currentColor"
              />
            </svg>
          </button>
          <div
            class="tw-grid tw-transition-[grid-template-rows,opacity] tw-duration-[280ms] tw-ease-[ease]"
            [ngClass]="
              comingSoonExpanded() ? 'tw-grid-rows-[1fr] tw-pointer-events-auto tw-opacity-100' : 'tw-grid-rows-[0fr] tw-pointer-events-none tw-opacity-0'
            "
            [attr.aria-hidden]="!comingSoonExpanded()"
          >
            <div class="tw-min-h-0 tw-overflow-hidden">
              <ul class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-2 tw-p-0">
                @for (field of comingSoonFields(); track field.form_element_type_id) {
                  <li class="tw-will-change-[opacity,transform]">
                    <button
                      type="button"
                      class="tw-relative tw-m-0 tw-flex tw-min-h-11 tw-w-full tw-cursor-default tw-items-center tw-gap-3 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-px-3 tw-py-2.5 tw-text-left"
                      [attr.title]="field.help_text"
                      (click)="onFieldClick(field)"
                    >
                      <i class="tw-h-4 tw-w-4 tw-shrink-0 tw-text-base tw-text-gray-300" [ngClass]="iconClass(field)" aria-hidden="true"></i>
                      <span class="tw-min-w-0 tw-flex-1 tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-400">{{ field.name }}</span>
                      <span class="tw-shrink-0 tw-rounded tw-bg-[#fdf6b2] tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-leading-4 tw-text-[#723b13]">Soon</span>
                    </button>
                  </li>
                }
              </ul>
            </div>
          </div>
        </section>
      </div>
    }
  </div>
</aside>
